<div class="form-group">
  <label for="{{fieldProps.key}}" class="label">{{fieldProps.title}}</label>

<ng-multiselect-dropdown *ngIf="edEnabled" [ngClass]="fieldProps.multiple === true ? 'multi-selection' : 'single-selection'"
placeholder="Seleccione un valor"
[settings]="fieldProps.multiple === true ? dropdownSettings : dropdownSettingsSingle"
[data]="entityElements"
[(ngModel)]="fieldProps.value" (onSelect)="onChange($event)" (onDeSelect)="onChange($event)" (onDropDownClose)="onCloseDropDown()">
</ng-multiselect-dropdown>

<input *ngIf="!edEnabled" readOnly="true" type="text" nbInput fullWidth  [(ngModel)]="fieldProps.value" >

</div>
